
import { defuFn } from '/root/workspace/whale-homepage_AeEf/node_modules/.pnpm/defu@6.1.4/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}



export default defuFn(inlineConfig)
